<ng-container>
    <div class="app-grid">
        <p>
            <strong>{{ 'forms.applicant-tracker.embeddingJobBoardIsEasy' | appTranslate }}</strong>
        </p>
        <ol>
            <li>
                <span class="no-margin">{{ 'forms.applicant-tracker.copyTheFollowingCode' | appTranslate }}</span>
                <div>
                    <mat-form-field class="embed-code-field">
                        <!--
                        Force prettier to keep the embed code without added line breaks or spaces
                        as they will be included in the textarea.
                        -->
                        <!-- prettier-ignore -->
                        <textarea
                            readonly
                            name="embedCode"
                            (click)="onClick($event)"
                            matInput
                            matTooltip="{{ 'forms.applicant-tracker.copied' | appTranslate }}"
                            #copyTooltip="matTooltip"
                            [matTooltipDisabled]="isCopyTooltipDisabled"
                            [matTooltipHideDelay]="2000"
                            matTooltipPosition="above"
                        >{{embedCode}}</textarea>
                    </mat-form-field>
                </div>
            </li>
            <li>
                <span
                    >{{
                        'forms.applicant-tracker.giveThisToThePersonResponsibleForDevelopingYourWebsiteTheyNeedTo'
                            | appTranslate
                    }}
                </span>
            </li>
            <li>
                <span [innerHTML]="'forms.applicant-tracker.thatsItCheckOutPageIfQuestions' | appTranslate"> </span>
            </li>
        </ol>
    </div>
</ng-container>
